// ------------------------------------
// props 輸入需求 : 
// props.data : object : { data: array }            (  )
// ------------------------------------

import React from 'react'


const ResidentArr =(props)=>{
    let res = props.res
    return(
        <div className={`res_layout ${props.type}`} 
            onMouseEnter={()=>props.setSelectionEff(true)} 
            onMouseLeave={()=>props.setSelectionEff(false)}
            onMouseDown={()=>props.setSelectionEff(true)}
            onClick={()=>{
                props.remove(res)
                props.setSelectionEff(false)
            }}>
            {props.selectionEff? <>
                <div className='corner_frame _bl'></div>
                <div className='corner_frame _br'></div>
                <div className='corner_frame _tl'></div>
                <div className='corner_frame _tr'></div>
            </>:null}
            {res[0]} {res[1]}
        </div>
    );	

}
export default ResidentArr;